const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.462,
    height: 20,
    viewBox: "0 0 18.462 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M156.154 54.039h-3.077v-.769a.769.769 0 1 0-1.538 0v.769h-5.385v-.769a.769.769 0 1 0-1.538 0v.769h-2.308A2.307 2.307 0 0 0 140 56.346v13.847a2.307 2.307 0 0 0 2.308 2.308h13.846a2.307 2.307 0 0 0 2.308-2.308V56.346a2.307 2.307 0 0 0-2.308-2.308zm-13.846 1.538h2.308v.769a.769.769 0 1 0 1.538 0v-.769h5.385v.769a.769.769 0 1 0 1.538 0v-.769h3.077a.769.769 0 0 1 .769.769v3.077h-15.385v-3.077a.769.769 0 0 1 .769-.769zm13.846 15.385h-13.846a.769.769 0 0 1-.769-.769v-9.231h15.385v9.231a.769.769 0 0 1-.769.769z",
    transform: "translate(-140 -52.5)",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateWidgetIcon);
export default __webpack_public_path__ + "static/media/date-widget-icon.923a161598b24a514235a4f0212597b0.svg";
export { ForwardRef as ReactComponent };